(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pause-check/assets/javascripts/pause-check.js') >= 0) return;  svs.modules.push('/components/tur/pause-check/assets/javascripts/pause-check.js');

'use strict';

svs.tur = svs.tur || {};
svs.tur.PauseCheck = class PauseCheck {
  static isBlocked() {
    return svs.core.userSession.isBlocked() || svs.tur.data.pauseCheck.isPaused;
  }
  static isBlockedWithDialog() {
    if (svs.tur.PauseCheck.isBlocked()) {
      let msg = 'Du kan tyvärr inte spela för att din Spelpaus är aktiv';
      if (svs.tur.data.pauseCheck.isPaused) {
        msg += " till ".concat(svs.utils.date.FormatTime('d/M, yyyy', svs.tur.data.pauseCheck.validTo || svs.tur.data.pauseCheck.terminable));
      }
      const dialog = new svs.components.dialog.Confirm({
        icon: 'spelpaus',
        branding: svs.components.dialog.branding.TUR,
        title: 'Din Spelpaus är aktiv',
        message: [{
          type: svs.components.dialog.message.TEXT,
          text: msg
        }],
        actions: [{
          title: 'Okej',
          callback: () => {
            dialog.close();
          }
        }]
      });
      svs.components.dialog.api.add(dialog);
      return true;
    }
    return false;
  }
};

 })(window);